<div class="toolbar">
    <div class="back-flex-container">
        <button type="button" class="btn" [routerLink]="['/']">
            <mat-icon>chevron_right</mat-icon>
        </button>
        <span class="fw-bold">بازگشت</span>
    </div>
    <input type="search" class="form-control" [(ngModel)]="searchKey" placeholder="جستجو..." autofocus>
</div>

<div class="table-responsive" *ngIf="(myRegistrations$ | async) as myRegistrations">
    <table class="app-table">
        <thead>
            <tr>
                <th class="fw-bold">ردیف</th>
                <th class="fw-bold">تاریخ ثبت نام</th>
                <th class="fw-bold">نام و نام خانوادگی</th>
                <th class="fw-bold">موبایل</th>
                <th class="fw-bold">وضعیت</th>
                <th class="fw-bold">اقساطی</th>
                <th class="fw-bold">مبلغ پرداخت شده(ریال)</th>
            </tr>
        </thead>
        <tbody>
            <ng-container
                *ngIf="myRegistrations | filter : searchKey : ['strName', 'strFamily', 'strMobile'] as myRegistrationsFiltered">
                <ng-container *ngIf="myRegistrationsFiltered.length;else elseTemplate">
                    <tr *ngFor="let myRegistration of myRegistrationsFiltered; let index = index"
                        (click)="openDtailsDialog(myRegistration)">
                        <td>{{index + 1}}</td>
                        <td>{{myRegistration.strRegisterDateTime}}</td>
                        <td>{{myRegistration.strName}} {{myRegistration.strFamily}}</td>
                        <td>{{myRegistration.strMobile}}</td>
                        <td>{{myRegistration.strInstallationStatus}}</td>
                        <td>{{myRegistration.bInstallment ? 'بله' : 'خیر'}}</td>
                        <td>{{myRegistration.iPayment1 | number}}</td>
                    </tr>
                </ng-container>

                <ng-template #elseTemplate>
                    <tr>
                        <td colspan="6">موردی یافت نشد.</td>
                    </tr>
                </ng-template>
            </ng-container>
        </tbody>
    </table>
</div>

<!-- Dtails Dialog -->
<ng-template #detailsDialogTemplate let-modal>
    <ng-container>
        <div class="modal-header">
            <h2 class="modal-title">نمایش اطلاعات</h2>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.close()"></button>
        </div>
        <div class="modal-body" [formGroup]="formGroup">
            <div class="grid-container">
                <div class="field-wrapper">
                    <label for="name-field">نام</label>
                    <input type="text" class="form-control" readonly id="name-field"
                        [value]="tankerProfile.strName || '-'">
                </div>
                <div class="field-wrapper">
                    <label for="family-field">نام خانوادگی</label>
                    <input type="text" class="form-control" readonly id="family-field"
                        [value]="tankerProfile.strFamily || '-'">
                </div>
                <div class="field-wrapper">
                    <label for="national-id-field">کد ملی مالک تانکر</label>
                    <input type="text" class="form-control direction-ltr" readonly id="national-id-field"
                        [value]="tankerProfile.strID || '-'">
                </div>
                <div class="field-wrapper">
                    <label for="mobile-field">موبایل</label>
                    <input type="text" class="form-control direction-ltr" readonly id="mobile-field"
                        [value]="tankerProfile.strMobile || '-'">
                </div>
                <div class="field-wrapper">
                    <label for="city-field">شهر</label>
                    <input type="text" class="form-control" readonly id="city-field"
                        [value]="tankerProfile.strCityName || '-'">
                </div>
                <div class="field-wrapper">
                    <label for="state-field">آدرس</label>
                    <input type="text" class="form-control" readonly id="state-field"
                        [value]="tankerProfile.strAddress || '-'">
                </div>
                <div class="field-wrapper">
                    <label for="date-field">تاریخ ثبت</label>
                    <input type="text" class="form-control direction-ltr" readonly id="date-field"
                        [value]="tankerProfile.strRegisterDateTime || '-'">
                </div>

                <div class="field-wrapper">
                    <label for="tracking-code-field">شماره پیگیری فیش پرداختی</label>
                    <input class="form-control direction-ltr" formControlName="iTrackingCode" inputmode="numeric"
                        oninput="this.value=this.value.replace(/[^0-9]/g,'')" id="tracking-code-field">
                </div>
                <div class="field-wrapper ">
                    <label for="iPayment1-field">مبلغ واریزی (ریال)</label>
                    <input class="form-control direction-ltr" formControlName="iPayment1" inputmode="numeric"
                        oninput="this.value=this.value.replace(/[^0-9]/g,'').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        id="iPayment1-field">
                </div>
                <div class="field-wrapper form-check form-switch d-flex align-items-center">
                    <input class="form-check-input m-0" type="checkbox" id="bInstallment"
                        formControlName="bInstallment">
                    <label class="form-check-label pointer text-muted me-2" for="bInstallment">پرداخت اقساطی</label>
                </div>
                <div class="field-wrapper textarea">
                    <div *ngIf="formGroup.get('bInstallment')?.value" class="form-group has-icon">
                        <span class="form-control-icon">
                            <mat-icon>description</mat-icon>
                        </span>
                        <textarea class="form-control" formControlName="strPaymentComment"
                            placeholder="توضیحات شرایط پرداخت ..."></textarea>
                    </div>
                </div>
                <div *ngIf="formGroup.get('bCanEdit')?.value" class="field-wrapper">
                    <button class="btn btn-primary" (click)="submitForm()">ویرایش</button>
                </div>
            </div>
        </div>
    </ng-container>
</ng-template>